export default __webpack_public_path__ + "static/media/bg_01.1af32acf.png";